<template>
  <div class="card-mask" v-show="value">
    <div class="card-wrapper" ref="wrapper">
      <div class="front" ref="front">
        <slot></slot>
      </div>
      <div class="back" ref="back">
        <img class="back-bg" :src="backBg[foodType]" alt="" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    foodType: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      backBg: {
        0: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/ad503043898e020b05f5ec4e8b1d138d.png',
        1: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/76e2aaabe765ecad366e6f96e3065692.png',
        2: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/7f242c90c3f20b0cb62f6a94f0de744a.png'
      }
    }
  },
  watch: {
    value() {
      if (this.value) {
        this.addAnimate()
      }
    }
  },
  methods: {
    addAnimate() {
      this.$nextTick(() => {
        let wrapper = this.$refs.wrapper
        let front = this.$refs.front
        let back = this.$refs.back
        let wrapperClassName = wrapper.className
        let frontClassName = front.className
        let backClassName = back.className
        wrapper.className = wrapperClassName + ' card-wrapper-animate'
        front.className = frontClassName + ' front-animate'
        back.className = backClassName + ' back-animate'
        setTimeout(() => {
          wrapper.className = wrapperClassName
          front.className = frontClassName
          back.className = backClassName
        }, 1000)
      })
    },
    bindClose() {
      this.$emit('input', false)
    }
  }
}
</script>
<style lang="scss" scoped>
.card-mask {
  left: 0;
  top: 0;
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 999;
  perspective: 1000px;
  border-radius: 8px;
}

.card-wrapper {
  width: 100%;
  height: 100%;
  position: relative;
  transform-style: preserve-3d;

  .front,
  .back {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    backface-visibility: hidden;
  }

  .front {
    z-index: 1;
  }

  .front-animate {
    animation: frontAnimate 1s ease;
  }

  .back {
    transform: rotateY(180deg);
    height: 100%;

    .back-bg {
      width: 100%;
      height: 100%;
    }
  }

  .back-animate {
    animation: backAnimate 1s ease;
  }
}

.card-wrapper-animate {
  animation: rotateAnimate 1s ease;
}

@keyframes frontAnimate {
  0% {
    transform: rotateY(180deg);
  }

  20% {
    transform: rotateY(180deg);
  }

  100% {
    transform: rotateY(0deg);
  }
}

@keyframes backAnimate {
  0% {
    transform: rotateY(0deg);
  }

  20% {
    transform: rotateY(0deg);
  }

  100% {
    transform: rotateY(180deg);
  }
}

@keyframes rotateAnimate {
  0% {
    transform: scale(0.1);
  }

  20% {
    transform: scale(0.3);
  }

  95% {
    transform: scale(1.03);
  }

  100% {
    transform: scale(1);
  }
}
</style>
